import React from "react";
import {ValueValidator} from "../Validator";
import {OnValidChangeHandler, ValidationComponent} from "./ValidationComponent";
import {RootState} from "../../../../app/store";
import {CustomTextAreaField} from "../../customTextAreaField/CustomTextAreaField";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined;
    fieldName: keyof OBJECT;
    onChange: (value: PROPERTY) => any,
    updateValidationStatus: OnValidChangeHandler<OBJECT>,
    label: string;
    maxLength: number;
    placeholder?: string;
    getMessage: (f: string) => string
    required?: boolean
}

export const ValidatedTextAreaField = <PROPERTY, OBJECT>({
                                                             validator,
                                                             selector,
                                                             fieldName,
                                                             onChange,
                                                             updateValidationStatus,
                                                             label,
                                                             maxLength,
                                                             placeholder,
                                                             getMessage,
                                                             required = true
                                                         }: Props<PROPERTY, OBJECT>) => {
    return <ValidationComponent<PROPERTY, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <CustomTextAreaField
                isRequired={required}
                title={label}
                value={value}
                setValue={onChange}
                maxLength={maxLength}
                placeholder={placeholder}
                errorMessage={getMessage(fieldName as string)}
            />
        }
    />
}
